define.alias("ember-concurrency/helpers/cancel-all", "preview-grid/helpers/cancel-all");